<template>
  <vessel-trial-table :id="id"></vessel-trial-table>
</template>

<script>
import VesselTrialTable from '@/components/tables/VesselTrialTable.vue'

export default {
  name: 'Vessels',
  components: {
    VesselTrialTable
  },
  props: {
    id: String
  }
}
</script>

<style scoped></style>
